import React from "react";
import * as S from './styles'

export type ListItemType = {
    children: JSX.Element | JSX.Element[] | String
    onClick?: React.MouseEventHandler<HTMLElement>
    active?: boolean
}

export const ListItem = ({children, onClick, active = false}: ListItemType) => {
    return (
        <S.ListItem active={active} onClick={onClick}>{children}</S.ListItem>
    )
}